<div class="feed-entry-actions overflow-hidden">
  <div kui-action>
    <kui-icon *ngFor="let action of actions" [name]="action.icon" (click)="action.onClick()" size="sm"></kui-icon>
  </div>
</div>
